<section class="session-error">
  <app-yes-no-dialog-box [visible]="true"
                         customContent="true"
                         customHeader="true"
                         [withoutCloseIcon]="true">
    <div header class="session-error__header">
      {{'shared.attention'|translate}}!
    </div>

    <div content>
      <section class="session-error__content content">
        <svg-icon [src]="'assets/icons/expired.svg'"
                  class="d-flex content__icon"></svg-icon>

        <p class="content__paragraph">
          {{'errors.expired-session'|translate }}
        </p>

        <section class="content__buttons-section">
          <button class="btn btn-primary content__button"
                  [translate]="'setting-menu.sign-out'" (click)="logOut()"></button>
        </section>
      </section>
    </div>
  </app-yes-no-dialog-box>
</section>
